import styled from 'styled-components';

const OurCleaningService = styled.div`
  .row {
    font-family: 'Open Sans', sans-serif;
    display: flex;
    background-color: #f5f5f5;
    width: 100%;
    height: 700px;
    gap: 30px;
    padding: 30px;
    margin-top: 120px;

    @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
      flex-direction: column;
      gap: 40px;
      align-items: center;
      justify-content: center;
      height: 950px;
      padding: 0;
    }

    .col_1 {
      width: 50%;
      overflow: hidden;
      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        width: 100%;
        height: 250px;
      }
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        border-radius: 20px;

        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          width: 100%;
          height: 100%;
        }
      }
    }
    .col_2 {
      width: 50%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: flex-start;
      gap: 10px;
      padding: 0 50px;

      @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
        padding: 0;
        gap: 30px;
        width: 100%;
        align-items: center;
      }

      h1 {
        font-family: 'Poppins', sans-serif;
        font-size: 2.3rem;
        font-weight: 600;
        letter-spacing: -1px;

        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          font-size: 2rem;
          font-weight: 600;
        }
      }

      P {
        line-height: 1.9;
        @media (max-width: ${({ theme }) => theme.breakpoints.tablet}) {
          text-align: center;
        }
      }

      ul {
        margin: 0;
        line-height: 1.9;
      }
      .button {
        background: ${(props) => props.theme.color.yellow};
        position: relative;
        /* Move overflow: hidden here to only affect the button */
        overflow: hidden;
        z-index: 1;
        text-decoration: none;
        font-family: 'Poppins', sans-serif;
        font-size: 1rem;
        padding: 15px 20px;
        border: none;
        border-radius: 35px;
        color: rgb(0, 0, 0);
        box-shadow: 0 8px 24px 0 rgba(0, 0, 0, 0.08);
        transition: color 0.3s cubic-bezier(0.4, 0, 0.2, 1);

        &::after {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          width: 50%;
          height: 100%;
          background: linear-gradient(
            120deg,
            rgba(255, 255, 255, 0.2) 0%,
            rgba(255, 255, 255, 0.7) 50%,
            rgba(255, 255, 255, 0.2) 100%
          );
          transform: skewX(-20deg);
          z-index: 2;
          transition: none;
          opacity: 0;
        }

        &:hover {
          color: #fff;
        }
        &:hover::after {
          opacity: 1;
          animation: shine 0.8s forwards;
        }
      }
      @keyframes shine {
        0% {
          left: 0;
        }
        60% {
          left: 120%;
        }
        100% {
          left: 120%;
        }
      }
    }
  }
`;

export default OurCleaningService;
